import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CampsService } from '../camps.service';
import { CampsModel } from '../CampsModel';
import { CampsImagesModel } from '../CampsImagesModel';
import { SearchModel } from '../../MasterData/SearchModel';
import { CountriesModel } from '../../MasterData/CountriesModel';
import { CountriesService } from '../../MasterData/countries.service';
@Component({
    // moduleId: module.id,
    selector: 'allcamps',
    templateUrl: 'allcamps.component.html',
    styleUrls: ['allcamps.component.scss']
})
export class AllcampsComponent implements OnInit {
    Menuoption = 'center';
    Settingicon = true
      projectDetails : any;
      projectGallaryConfig  = {"slidesToShow": 1,"fade": true, "slidesToScroll": 1,"arrows": false,"dots": false,"autoplay": true, "autoplaySpeed": 2000};
    declare lang: any;
  
      constructor( 
          public router: Router,
          private formBuilder : FormBuilder,
          private CountriesService:CountriesService,
          private modelService :CampsService,
          private route: ActivatedRoute,
          ) {      this.id = +route.snapshot.paramMap.get("id");
         }
         id=0;
         ngOnInit() {
          this.lang = localStorage.getItem('theme_lang');
          debugger;
          this.modelService.getAll().subscribe(data=>{
              this.rows=data;
              console.log("modelObject",this.rows)
          })
          this.CountriesService.getAll().subscribe(data=>{
            this.CountriesList=data;
          })
          if(this.id > 0)
          {
            debugger;
            this.modelService.getById(this.id).subscribe(data=>{
              this.modelObject=data;
              this.files=this.modelObject.campingImagesList;
              this.files.forEach(element => {
                this.setImage(element.campingId);
              });
              console.log("modelObject",this.rows)
              // this.mainForm = this.createForm(this.modelObject);
  
            })
  
          }
          else{
          //   this.mainForm = this.createForm(this.modelObject);                              
          }
  
          // this.GetAllCountries();
          // this.mainForm = this.createForm(this.modelObject); 
      }
      selectedIndex: number = 0;
      @Input()
      data:any;
      modelObject: CampsModel = new CampsModel();
      rows :CampsModel[]= [];
  
      mainForm: FormGroup = new FormGroup({
          id: new FormControl(),
          images: new FormControl(),
          titleAr: new FormControl(),
          titleEn: new FormControl(),
          titleFr: new FormControl(),
          descriptionAr: new FormControl(),
          descriptionEn: new FormControl(),
          descriptionFr: new FormControl(),
          latitude: new FormControl(),
          longitude: new FormControl(),
          countryId: new FormControl(),
          cityId: new FormControl(),
          userId: new FormControl(),
          date: new FormControl(),
      });
     
        files:CampsImagesModel[]=[];
       public picurl: string ='';
       editEnabled = true;
        setFileToList(){
          debugger;
            var file = new CampsImagesModel();
            file.campingId = this.id ;
            file.imageURL = this.picurl;
            file.id = 0;
            this.picurl='';
            this.editEnabled = true;
            this.files.push(file);
        }
        goBack(){
          this.router.navigate(['/blimp/events']);
        }
    selectedImages:CampsImagesModel={};
    CountriesList :CountriesModel[]= [];
    SearchObject:SearchModel={};
    countryId=0;
    fromDate=new Date();
    toDate=new Date();
    Search(){
      debugger;
      this.SearchObject = new SearchModel();
      this.SearchObject.countryId = +this.countryId;
      this.SearchObject.fromDate = this.fromDate;
      this.SearchObject.toDate = this.toDate;
           this.modelService.GetAllByDate(this.SearchObject).subscribe(data=>{
             this.rows=data;
           })
       }
        setImage(EventId){
          debugger;
          var i = this.files.findIndex(x=>x.campingId == this.id);
          if(i>-1){
            this.selectedImages = this.files[i];
          }
          else{
            this.selectedImages.imageURL=''
          }
          
        }
        CampDetails(id){
          this.router.navigate(['/camps-details/',id]);
          
        }
  }
  